///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Modal from "../../Modal";
import messages from "../../../helpers/messages";

export const ConfirmCancellationModal = ({ open, closeModal, handleExit }) => (
  <Modal
    title={messages.confirmCancellation.defaultMessage}
    open={open}
    handleClose={closeModal}
    titleClass="modal__title_light uppercase"
    bodyClass="border-top-grey px-24 pt-24"
    closeButtonClass="modal__close-button mr-16 mt-16"
    large={true}
  >
    <p
      data-testid="cancellation-modal"
      className="font-size-16 text-dim-grey pb-8"
    >
      {messages.confirmCancellationMessage.defaultMessage}
    </p>
    <div className="grid fr">
      <div className="grid__cell pr-8">
        <button
          data-testid="stay-button"
          className="secondary-button one-whole cursor-pointer univers-67-bold-cond"
          onClick={closeModal}
        >
          {messages.stay.defaultMessage}
        </button>
      </div>
      <div className="grid__cell pl-8">
        <button
          data-testid="exit-button"
          className="primary-button one-whole cursor-pointer univers-67-bold-cond"
          onClick={handleExit}
        >
          {messages.exit.defaultMessage}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmCancellationModal;
